export default __webpack_public_path__ + "static/media/Fall_11.039a071f.png";